module.exports = __webpack_public_path__ + "img/首图背景@2x.8bf3abee.png";